import { Reveal, SectionHead } from "./Reveal";

const STATS = [
  { value: "100%+", label: "ROI Improvement", note: "Delivered for a mid-market B2B SaaS client within 6 months — without increasing total spend." },
  { value: "56%+", label: "Conversion Lift", note: "Full-funnel rebuilds that turn existing traffic into revenue." },
  { value: "48%+", label: "Retention Growth", note: "Customer-first engagement systems that compound over time." },
  { value: "22%", label: "CAC Reduction", note: "Achieved for a fintech client within 90 days of a paid-media audit." },
];

const Results = () => (
  <section id="results" data-testid="results-section" className="relative px-6 md:px-12 py-24 md:py-36 border-t border-line overflow-hidden">
    <div
      aria-hidden="true"
      className="absolute inset-0 opacity-[0.06] bg-cover bg-center reduce-motion-hidden"
      style={{ backgroundImage: "url(https://images.unsplash.com/photo-1752981560841-258cb3e8c370?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwzfHxtaW5pbWFsaXN0JTIwYWJzdHJhY3QlMjBkYXRhJTIwZ3Jvd3RoJTIwY2hhcnQlMjBhcnR8ZW58MHx8fHwxNzg3NDIwOTMwfDA&ixlib=rb-4.1.0&q=85)" }}
    />
    <div className="relative mx-auto max-w-[100rem]">
      <SectionHead
        index="02"
        label="Results"
        title={<>Numbers that speak <em className="text-taupe">before I do.</em></>}
      />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 border-t border-l border-line">
        {STATS.map((s, i) => (
          <Reveal key={s.label} delay={i * 0.08} className="border-b border-r border-line">
            <div data-testid={`stat-${s.label.toLowerCase().replace(/\s+/g, "-")}`} className="group p-8 md:p-10 h-full hover:bg-ink transition-colors duration-500">
              <p className="font-serif text-6xl md:text-7xl font-light tracking-tighter group-hover:text-paper transition-colors duration-500">
                {s.value}
              </p>
              <p className="mt-4 text-xs uppercase tracking-[0.25em] text-taupe">{s.label}</p>
              <p className="mt-4 text-sm font-light text-ash leading-relaxed group-hover:text-paper/70 transition-colors duration-500">
                {s.note}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Results;
